const isCanceledRequest = (error) =>
    error?.name === 'CanceledError'
    || error?.name === 'AbortError'
    || error?.code === 'ERR_CANCELED';

const isTimeoutRequest = (error) =>
    error?.code === 'ECONNABORTED'
    || error?.code === 'ETIMEDOUT'
    || error?.name === 'TimeoutError';

/**
 * Extract bounded transport facts from an HTTP-client error.
 *
 * This function does not decide event severity, business outcome, or user
 * impact. A service may record these mechanical facts; the operation handling
 * the result owns their business meaning. Raw errors, messages, response
 * bodies, configs, and URLs are never returned.
 *
 * @param {Object} error
 * @returns {{ failure_category: string, status_code?: number }}
 */
export const getRequestFailureDetails = (error) => {
    if (isCanceledRequest(error)) {
        return { failure_category: 'canceled' };
    }

    if (isTimeoutRequest(error)) {
        return { failure_category: 'timeout' };
    }

    if (error?.response) {
        const statusCode = error.response.status;
        return {
            failure_category: 'http',
            ...(typeof statusCode === 'number'
                ? { status_code: statusCode }
                : {}),
        };
    }

    if (error?.request) {
        return { failure_category: 'network' };
    }

    return { failure_category: 'request' };
};
